<div class="uppercase">
  <p-steps [activeIndex]="step()" [model]="steps()" [readonly]="true"></p-steps>
</div>
